/* ec-currency.js — gosterim katmani kur donusumu (yaklasik fiyat).
   GERCEK TAHSILAT HER ZAMAN USD (Shopify Payments yok) — bu katman yalniz
   [data-ec-cents] tasiyan SSR fiyatlari ve ECFX.fmt uzerinden gelen dinamik
   fiyatlari ziyaretcinin para biriminde "≈" onekiyle gosterir.
   Kur: frankfurter.app (ECB, anahtarsiz) — 24 saat localStorage cache,
   servis olursa bayat cache, o da yoksa USD'ye sessiz dusus. */
(function () {
  'use strict';
  if (window.ECFX) return;

  var BASE = 'USD';
  var CURS = ['EUR', 'GBP', 'CAD', 'AUD', 'NZD', 'TRY', 'CHF', 'SEK', 'NOK', 'DKK', 'JPY'];
  var REGION_MAP = {
    GB: 'GBP', IM: 'GBP', JE: 'GBP', GG: 'GBP',
    CA: 'CAD', AU: 'AUD', NZ: 'NZD', TR: 'TRY',
    CH: 'CHF', LI: 'CHF', SE: 'SEK', NO: 'NOK',
    DK: 'DKK', FO: 'DKK', GL: 'DKK', JP: 'JPY',
    AT: 'EUR', BE: 'EUR', CY: 'EUR', DE: 'EUR', EE: 'EUR', ES: 'EUR', FI: 'EUR',
    FR: 'EUR', GR: 'EUR', HR: 'EUR', IE: 'EUR', IT: 'EUR', LT: 'EUR', LU: 'EUR',
    LV: 'EUR', MT: 'EUR', NL: 'EUR', PT: 'EUR', SI: 'EUR', SK: 'EUR',
    MC: 'EUR', SM: 'EUR', AD: 'EUR', ME: 'EUR', XK: 'EUR'
  };
  var TTL = 86400000; /* 24h */
  /* Gomulu tohum kurlar (ECB 2026-07-10) — canli kur servisi ulasilamazsa USD'ye
     dusmek yerine bunlarla calisir; '≈' yaklasiklik etiketi kucuk sapmayi kapsar.
     Canli fetch basarili oldugunda localStorage cache bunlarin onune gecer. */
  var SEED_RATES = { AUD: 1.4389, CAD: 1.4153, CHF: 0.80691, DKK: 6.5399, EUR: 0.87489, GBP: 0.74501, JPY: 161.87, NOK: 9.7537, NZD: 1.733, SEK: 9.6365, TRY: 46.985 };
  var state = { currency: BASE, rate: 1, active: false, country: '' };

  /* magaza para birimi USD degilse guvenlik icin hic calisma */
  if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active && window.Shopify.currency.active !== BASE) return;

  function navRegionCurrency() {
    var reg = ((navigator.language || '').split('-')[1] || '').toUpperCase();
    return REGION_MAP[reg] || BASE;
  }
  /* Ulke tespiti IP-tabanli (Shopify same-origin endpoint) — tarayici dili
     yaniltir (TR'de en-US kullanimi yaygin -> yanlislikla USD kaliyordu, 11.07).
     Oncelik: kullanici secimi (localStorage) > IP ulkesi (24s cache) > dil > USD. */
  function detectAsync(cb) {
    try { var s = localStorage.getItem('ec_currency'); if (s && (s === BASE || CURS.indexOf(s) > -1)) return cb(s); } catch (e) {}
    var g = null;
    try { g = JSON.parse(localStorage.getItem('ec_geo') || 'null'); } catch (e) {}
    if (g && g.c && (Date.now() - g.t) < TTL) { state.country = (g.c || '').toUpperCase(); return cb(REGION_MAP[g.c] || BASE); }
    fetch('/browsing_context_suggestions', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('geo http'); return r.json(); })
      .then(function (j) {
        var cc = (((j || {}).detected_values || {}).country || {}).handle || '';
        state.country = (cc || '').toUpperCase();
        if (cc) { try { localStorage.setItem('ec_geo', JSON.stringify({ t: Date.now(), c: cc })); } catch (e) {} }
        cb(cc ? (REGION_MAP[cc] || BASE) : navRegionCurrency());
      })
      .catch(function () { cb(navRegionCurrency()); });
  }

  function cachedRates() {
    try {
      var raw = localStorage.getItem('ec_fx');
      if (!raw) return null;
      var o = JSON.parse(raw);
      return (o && o.r) ? o : null;
    } catch (e) { return null; }
  }

  function fetchRates() {
    /* .app domaini 301 -> .dev/v1 yonlendiriyor ve yonlendirmede CORS basligi yok (19.07 canli tespit) */
    return fetch('https://api.frankfurter.dev/v1/latest?from=' + BASE + '&to=' + CURS.join(','))
      .then(function (r) { if (!r.ok) throw new Error('fx http ' + r.status); return r.json(); })
      .then(function (j) {
        if (!j || !j.rates) throw new Error('fx body');
        var o = { t: Date.now(), r: j.rates };
        try { localStorage.setItem('ec_fx', JSON.stringify(o)); } catch (e) {}
        return o;
      });
  }

  /* Psikolojik taban: buyukluge gore 9-sonlu cazip rakam (149 / 129 / 7.990 / 15.900).
     KURAL (guncel): YALNIZ YUKARI yuvarla, en fazla +%5 — gosterilen deger gercek
     karsiliginin ASLA altinda kalmasin (PDP charm -> sepette birebir gecisinde fiyat
     ZIPLAMASIN; bayat kurda bile musteri checkout'ta gordugunden pahali odemesin).
     Koridorda aday yoksa birebir kal. */
  function charm(v) {
    if (v < 50) {
      var d = Math.floor(v) + 0.90;
      if (d < v) d = Math.floor(v) + 1.90;
      if (d >= v && d <= v * 1.05) return d;
      return v;
    }
    var g = Math.pow(10, Math.max(0, Math.floor(Math.log(v) / Math.LN10) - 2));
    var step = 10 * g;
    var up = Math.ceil(v / step) * step - g;
    if (up < v) up += step;
    if (up >= v && up <= v * 1.05) return up;
    return v;
  }

  function fmt(cents, useCharm) {
    if (!state.active) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: BASE }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    }
    var v = (cents * state.rate) / 100;
    if (useCharm) v = charm(v);
    var opts = { style: 'currency', currency: state.currency };
    if (Math.abs(v - Math.round(v)) < 0.005) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
    try {
      return '≈ ' + new Intl.NumberFormat(navigator.language || 'en', opts).format(v);
    } catch (e) { return '≈ ' + v.toFixed(2) + ' ' + state.currency; }
  }

  function apply(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-ec-cents]').forEach(function (el) {
      var c = parseInt(el.getAttribute('data-ec-cents'), 10);
      if (!isFinite(c)) return;
      /* sepet/toplam birebir (kalemler toplami tutmali); katalog fiyati psikolojik taban */
      var exact = el.closest && el.closest('.ec-cd, .ec-summary, .ec-item, [data-ec-fx-exact]');
      var t = fmt(c, !exact);
      if (el.textContent !== t) el.textContent = t; /* idempotent: observer dongusunu kirar */
    });
    document.querySelectorAll('[data-ec-fx-note]').forEach(function (n) {
      n.classList.toggle('is-on', state.active);
    });
    document.querySelectorAll('[data-ec-fx-cur]').forEach(function (s) {
      if (s.textContent !== state.currency) s.textContent = state.currency; /* kosulsuz yazma 11.07 kilit dongusunun koku idi */
    });
    document.querySelectorAll('select[data-ec-fx-select]').forEach(function (sel) { sel.value = state.currency; });
  }

  function activate(want, rates) {
    if (want !== BASE && rates && rates[want]) {
      state.currency = want; state.rate = rates[want]; state.active = true;
    } else {
      state.currency = BASE; state.rate = 1; state.active = false;
    }
    apply();
    document.dispatchEvent(new CustomEvent('ec:fx:ready', { detail: { currency: state.currency, active: state.active } }));
  }

  function boot() {
    detectAsync(function (want) {
      if (want === BASE) { activate(BASE, null); ratesWarm(); return; }
      var c = cachedRates();
      if (c && (Date.now() - c.t) < TTL) { activate(want, c.r); return; }
      fetchRates().then(function (o) { activate(want, o.r); })
        .catch(function () { activate(want, c ? c.r : SEED_RATES); }); /* bayat cache > tohum > (asla USD'ye dusme) */
    });
  }
  /* USD kullanicisi secici acarsa kur hazir olsun diye sessiz isitma */
  function ratesWarm() {
    var c = cachedRates();
    if (!c || (Date.now() - c.t) >= TTL) { fetchRates().catch(function () {}); }
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('select[data-ec-fx-select]');
    if (!sel) return;
    var v = sel.value;
    try { localStorage.setItem('ec_currency', v); } catch (e2) {}
    location.reload();
  });

  document.addEventListener('shopify:section:load', function (e) { apply(e.target); });

  /* Drawer sunucudan yenilenen HTML'ini EC cart olaylari sonrasi donustur —
     MutationObserver YERINE EventBus+gecikme (observer surumu sayfayi kilitledi, 11.07).
     core.js defer siralamasi geregi EC bu scriptten once yuklenir. */
  function afterCartChange() { setTimeout(apply, 350); setTimeout(apply, 1200); }
  (function bindFxCart(tries) {
    if (window.EC && window.EC.on) {
      ['cart:added', 'cart:updated', 'cart:error'].forEach(function (ev) { window.EC.on(ev, afterCartChange); });
    } else if (tries < 40) {
      /* core.js henuz yuklenmediyse birazdan tekrar dene — abonelik sessizce dusmesin */
      setTimeout(function () { bindFxCart(tries + 1); }, 100);
    }
  })(0);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-ec-cart-open], .ec-header__cart, a[href="/cart"]')) {
      setTimeout(apply, 400);
    }
  });

  window.ECFX = {
    get active() { return state.active; },
    get currency() { return state.currency; },
    get country() { return state.country; },
    fmt: fmt, /* birebir (sepet) */
    fmtCharm: function (cents) { return fmt(cents, true); }, /* katalog — psikolojik taban */
    apply: apply
  };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
